import React from 'react';
import ConfluencePage from '../ConfluencePage/ConfluencePage';
import { PROJECTS } from '../../constants/confluenceConstants';
import '../../css/confluence.css';

const Projects = () => {
  return (
    <ConfluencePage pageName={PROJECTS} />
  );
};

export default Projects;
